import { getGraduateGradeLabel } from "./academicGrades";

export type LeagueParticipantType =
  | "regular"
  | "university"
  | "graduate"
  | "professional";

export type LeagueGradeOption = {
  value: string;
  label: string;
};

export const gradesByParticipantType: Record<
  LeagueParticipantType,
  LeagueGradeOption[]
> = {
  regular: ["中1", "中2", "中3", "高1", "高2", "高3"].map((grade) => ({
    value: grade,
    label: grade,
  })),
  university: [
    { value: "大1", label: "大学1年（高専4年）" },
    { value: "大2", label: "大学2年（高専5年）" },
    { value: "大3", label: "大学3年" },
    { value: "大4", label: "大学4年" },
  ],
  graduate: [
    { value: "院1", label: getGraduateGradeLabel("院1") },
    { value: "院2", label: getGraduateGradeLabel("院2") },
    { value: "院3", label: getGraduateGradeLabel("院3") },
    { value: "院4", label: getGraduateGradeLabel("院4") },
    { value: "院5", label: getGraduateGradeLabel("院5") },
  ],
  professional: [{ value: "社会人", label: "社会人" }],
};

export function getLeagueGradeOptions(
  participantType: LeagueParticipantType
) {
  return gradesByParticipantType[participantType];
}
